import { Injectable } from "@angular/core";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { StudentFormDataService } from "common/services/data-services/admin/students/students-form-data.service";
import { API_URL } from "common/constants/sm-constants";
import { StudentsModel } from "common/models/page-models/student/formmodel/student-data.model";
import { StudentsFormMetaModel } from "common/models/page-models/student/formmodel/student-meta.model";
import { MentorMappingListDataService } from "common/services/data-services/custom-service/mentor-list-service";
import { BatchesGridDataService } from "common/services/data-services/admin/batches/batches-grid-data.services";
import { environment } from "src/environments/environment";
import { SystemService } from "common/services/core-services/system.service";
import { DistrictDataService } from "common/services/data-services/custom-service/district-data.service";



@Injectable({
    providedIn: 'root'
})
export class StudentsFormWidgetService extends FormWidgetService<StudentsModel> {


    constructor(protected ds: StudentFormDataService, protected batchDataService: BatchesGridDataService, private mentorListService: MentorMappingListDataService, private ss: SystemService, private districtService: DistrictDataService) {

        super(ds);
        
    }

    getMetaModel(): MetaModel {
        const meta = new StudentsFormMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: StudentsModel, metaModel: StudentsFormMetaModel, routeData: WidgetModel, event: any = null): Promise<StudentsFormMetaModel> {
        return new Promise<StudentsFormMetaModel>((resolve, reject) => {
            this.mentorListService.postData('').then(data => {
                metaModel.properties.mentorId.options = data['details'];
            });


            // this.districtService
            //     .postData({
            //         state_id: 258,
            //     })
            //     .then((data) => {
            //         metaModel.properties.properties['district_id'].options =
            //             data.details;
            //     });

            this.ds.setSystemServiceData('', API_URL.stateList, ' ', 'details').then((data) => {
                metaModel.properties.state_id.options = data.details
                metaModel.properties.batch_id.options = routeData.transferData.batch
                metaModel.properties.region_id.options = routeData.transferData.region
                metaModel.properties.branch_id.options = routeData.transferData.branch
                resolve(metaModel);
            }).catch((err) => {
                reject(err)
            }
            );
        });
    }

    changeMentor(payload) {
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.notifyParticularStudentForAssignedMentor).then((data) => {
            this.ss.showSuccess(data['header'].msg)
        })
    }
}